import { IPromise, IScope } from 'angular'
import { $q } from '../../../ng-compat/imports'

interface LSPayRecoveryModalOptions {
  saleId: string
}

/**
 * Controller class for the lspay recovery modal component
 *
 * @class LSPayRecoveryModalController
 */
export class LSPayRecoveryModalController {
  public readonly saleId: string
  public readonly close: () => void
  private readonly internalClose: (val: IPromise<boolean>) => void

  constructor(
    $scope: IScope,
    close: () => void,
    public readonly options: LSPayRecoveryModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.saleId = options.saleId
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
